import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

axios.defaults.withCredentials = true;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest

  useEffect(() => {
    axios.get(`${API}/auth/me`).then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch {}
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
}
